import { render, staticRenderFns } from "./ModernVaraSelect.vue?vue&type=template&id=665b7ab7"
import script from "./ModernVaraSelect.vue?vue&type=script&lang=js"
export * from "./ModernVaraSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports